/**
 * Default fraction of the available height the map occupies in layouts that
 * pair the geo area map with the range slider. "Available height" is whatever
 * the caller passes into `getMapHeight` — usually the sheet height for bottom
 * sheets or the window height for full-screen layouts. The containing view
 * must additionally reserve `RANGE_SLIDER_HEIGHT` below the map so the thumb
 * is not clipped.
 */
export const MAP_HEIGHT_RATIO = 0.35;

/**
 * Smaller ratio for the sticky-button variant of `GeoAreaSubscription` so the
 * chip list stays reachable without an excessive scroll offset.
 */
export const MAP_HEIGHT_RATIO_STICKY = 0.28;

/** Lower bound for the computed map height so it stays usable on small devices. */
export const MAP_MIN_HEIGHT = 240;

/** Upper bound for the computed map height so it does not dominate on tablets. */
export const MAP_MAX_HEIGHT = 420;

/**
 * Computes the map height from the height available to the sheet, clamped to
 * sensible bounds so it neither collapses on small phones nor grows too large
 * on tablets.
 */
export const getMapHeight = (
  availableHeight: number,
  ratio: number = MAP_HEIGHT_RATIO
): number =>
  Math.min(Math.max(availableHeight * ratio, MAP_MIN_HEIGHT), MAP_MAX_HEIGHT);
